import React from 'react';

import { Container, Step } from './styles';

function Stepper({ stepsQtd = 2, activeStep = 1 }) {
  function renderSteps() {
    let steps = [];
    for (let index = 1; index <= stepsQtd; index++) {
      steps.push(<Step key={index} active={activeStep === index} />);
    }
    return steps;
  }

  return <Container>{renderSteps()}</Container>;
}

export default Stepper;
